export default __webpack_public_path__ + "static/media/prev.32b61acd.svg";